import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import color1 from "../../assets/images/dummy/color1.png";
import color2 from "../../assets/images/dummy/color2.png";
import color3 from "../../assets/images/dummy/color3.png";
import Y_Us_StripComponent from "../common/Y_us_strip";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Constants from "../Variables/Constants";
import axios from "axios";
import { toast } from "react-toastify";
const ColorCombinationProducts = () => {
  const [allSubCategory, setAllSubcategory] = useState([]);
  const [allProduct, setAllProducts] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");
  const [activeCategoryId, setActiveCategoryId] = useState(null);
  const [getProductList, setAllProductList] = useState([]);
  const [limit, setLimit] = useState(10);

  const location = useLocation();
  const { collectionData, slug } = location.state || {};
  const token = localStorage.getItem("token") || "";
  const navigate = useNavigate();

  // getProductList

  useEffect(() => {
    if (collectionData.category_id._id) {
      setProductList(collectionData.category_id._id);
    }
    // getSingleStyle();
  }, []);

  // const getSingleStyle = () => {
  //   axios
  //     .get(
  //       Constants.getUrls.getSingleStyle +
  //         "/" +
  //         window.location.pathname.split("/")[2]
  //     )
  //     .then(async (data) => {
  //       console.log(
  //         "data.data.category_id",
  //         data.data,
  //         data.data.data.category_id
  //       );
  //       if (data.data.status == "success") {
  //         if (data.data.data) {
  //           setCategoryId(data.data.data.category_id);
  //           setSubCategoryId(data.data.data.subcategory_id);

  //           const resp = await axios.get(
  //             `${Constants.getUrls.getAllCollections}?limit=${100}&cateId=${
  //               data.data.data.category_id
  //             }`
  //           );
  //           if (resp.data.status === "success") {
  //             if (resp.data.data.docs.length > 0) {
  //               setAllSubcategory(resp.data.data.docs);
  //             }
  //           }
  //           setProductList(data.data.data.subcategory_id);
  //         }
  //       }
  //     })
  //     .catch((error) => {});
  // };

  // const handleClick = (id) => {
  //   setLimit(10);
  //   setProductList(id);
  //   setActiveCategoryId(id);
  // };

  const getAdminCustomization = async (product_id) => {
    const result = await axios.get(Constants.getUrls.getAdminCustomizedImage + `/${product_id}`);
    if (result.data.status === "success") {
      return result.data.data[0];
    }
  }

  const fetchMoreData = () => {
    setLimit((prevCount) => prevCount + 10);
    setProductList(collectionData.category_id._id || "");
  };
  const setProductList = (id) => {
    setActiveCategoryId(id);

    axios
      .get(
        `${Constants.getUrls.getAllProducts}?limit=${limit}&sub_category=${window.location.pathname.split("/")[2]
        }&category=${id}`
      )
      .then((resp) => {
        if (resp.data.status === "success") {
          setAllProductList(resp.data.data.docs);
        }
      })
      .catch((error) => {
        console.error("Error in stylesChange:", error);
      });
  };

  const handleProductClick = async (product) => {
    // if (slug === "tallistefillin-bags" && !token) {
    //   toast.warning("Please login for customization");
    //   navigate("/login", { state: { slug, product_id: product._id, isCustomizationRedirect: true } });
    //   return;
    // }

    const state = {
      slug
    }

    if (slug === "tallistefillin-bags") {
      const data = await getAdminCustomization(product._id);

      if (data) {
        state.designData = data;
      }
    }

    // Navigate to the appropriate page
    const path =
      slug === "tallistefillin-bags"
        ? `/build_your_custom_beteil/${product._id}/product`
        : `/product_detail/${product._id}`;

    navigate(path, { state: state });
  };

  const ExploreProductsOptions = {
    navText: [
      "<i className='bi bi-chevron-left'><</i>",
      "<i className='bi bi-chevron-right'>></i>",
    ],
    items: 3,
    loop: false,
    nav: true,
    dots: false,
    responsive: {
      1: {
        items: 2,
        margin: 10,
      },
      600: {
        items: 2,
        margin: 10,
      },
      // 900: {
      //   items: 3,
      //   margin: 15,
      // },
      // 1025: {
      //   items: 3,
      //   margin: 20,
      // },
      // 1200: {
      //   items: 3,
      //   margin: 30,
      // },
    },
  };

  return (
    <section className="build_your_custom_beteil">
      <div className="container">
        {/*     <nav className="my-5 font-poppins route-navigation">
          <ul className="d-flex gap-4 text-light-gray fs-20 fw-semibold ">
            <Link to={"/"}>
              <li className="list-unstyled">HOME</li>
            </Link>
            <li className="list-unstyled">
              <img loading="lazy"  src={rightArrow} alt="" />
            </li>
            <li className="list-unstyled text-dark text-light-yellow">
              {path}
            </li>
          </ul>
        </nav> */}

        <div className="row w-100 align-items-center justify-content-around mt-4">
          <div className="col-lg-6 col-md-12 col-12">
            <div className="text-warning text-center mb-lg-0 mb-md-5 mb-5 fs-24 fw-medium mt-4">
              Which product hit your eye?
            </div>
          </div>
          {/* <div className="col-lg-4 col-md-12 col-12"> */}
          {/* <ul className="nav ms-5 nav-pills mt-4"> */}
          {/*  <Button className="rounded-5 bg-transparent">
                <img loading="lazy" 
                  src="https://img.icons8.com/carbon-copy/100/right-squared.png"
                  alt="right-squared"
                />
              </Button> */}
          {/* {allSubCategory.length > 0 ? (
                <OwlCarousel {...ExploreProductsOptions}>
                  {allSubCategory.map((category, i) => (
                    <div
                      className="item "
                      key={i}
                      id={`subcat_${category._id}`}
                    >
                      <li
                        className={`fs-18 py-3  text-center fw-medium rounded-4 overflow-hidden ${
                          activeCategoryId === category._id ? "Active" : ""
                        }`}
                        onClick={() => handleClick(category._id)}
                        id={`subcatli_${category._id}`}
                      >
                        {category.title}
                      </li>
                    </div>
                  ))}
                </OwlCarousel>
              ) : (
                <p>Loading category...</p>
              )} */}
          {/* <OwlCarousel {...ExploreProductsOptions}>
                <div className="item">
                  <li className="fs-18 py-3 Active text-center fw-medium rounded-4 overflow-hidden">
                    Leather
                  </li>
                </div>
                <div className="item">
                  <li className="fs-18 py-3 text-center fw-medium rounded-4 overflow-hidden">
                    Cowhide
                  </li>
                </div>
                <div className="item">
                  <li className="fs-18 py-3 text-center fw-medium rounded-4 overflow-hidden">
                    Velvet
                  </li>
                </div>
                <div className="item">
                  <li className="fs-18 py-3 text-center fw-medium rounded-4 overflow-hidden">
                    Velvet
                  </li>
                </div>
                <div className="item">
                  <li className="fs-18 py-3 text-center fw-medium rounded-4 overflow-hidden">
                    Velvet
                  </li>
                </div>
              </OwlCarousel> */}
          {/*   <Button className="rounded-5 bg-transparent">
                <img loading="lazy" 
                  src="https://img.icons8.com/carbon-copy/100/right-squared.png"
                  alt="right-squared"
                />
              </Button> */}
          {/* </ul> */}
          {/* </div> */}
        </div>
        <section className="my-5">
          <div className="d-flex gap-4 justify-content-center">
            {getProductList.length > 0 ? (
              getProductList.map((product, i) => (
                <div className="" key={product._id}>
                  {/* <Link 
                      to={ slug === "tallistefillin-bags" ? 
                        (token ? `/build_your_custom_beteil/${product._id}/product` : `/login`) : `/product_detail/${product._id}`}
                      state={{ slug: slug, product_id: product._id, isCustomizationRedirect: true }}
                    > */}
                  <div
                    className="size d-flex justify-content-center align-items-center text-center gap-5"
                    onClick={() => handleProductClick(product)}
                    style={{ cursor: "pointer" }}
                  >
                    <img loading="lazy" 
                      className="img-fluid"
                      src={
                        product.images.length > 0
                          ? Constants.imgDomain + product.images[0]
                          : ""
                      }
                      alt="No Image"
                    />
                  </div>
                  {/* </Link> */}

                  <h2 className="text-center text-capitalize mt-3">{product.name}</h2>
                </div>

              ))
            ) : (
              <p>Loading products...</p>
            )}
          </div>
          {/* <div className="col-xl-2 col-lg-3 col-md-4 col-12">
              <Link to={"/build_your_custom_beteil/product"}>
                <div className="explore_our_products_card  d-flex justify-content-center align-items-center text-center bg-transparent">
                  <img loading="lazy"  src={color1} alt="banner-1" />
                </div>
              </Link>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-4 col-12">
              <Link to={"/build_your_custom_beteil/product"}>
                <div className="explore_our_products_card  d-flex justify-content-center align-items-center bg-transparent">
                  <img loading="lazy"  src={color2} alt="banner-1" />
                </div>
              </Link>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-4 col-12">
              <Link to={"/build_your_custom_beteil/product"}>
                <div className="explore_our_products_card  d-flex justify-content-center align-items-center bg-transparent">
                  <img loading="lazy"  src={color1} alt="banner-1" />
                </div>
              </Link>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-4 col-12">
              <Link to={"/build_your_custom_beteil/product"}>
                <div className="explore_our_products_card  d-flex justify-content-center align-items-center bg-transparent">
                  <img loading="lazy"  src={color3} alt="banner-1" />
                </div>
              </Link>
            </div>

            <div className="col-xl-2 col-lg-3 col-md-4 col-12">
              <Link to={"/build_your_custom_beteil/product"}>
                <div className="explore_our_products_card  d-flex justify-content-center align-items-center bg-transparent">
                  <img loading="lazy"  src={color2} alt="banner-1" />
                </div>
              </Link>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-4 col-12">
              <Link to={"/build_your_custom_beteil/product"}>
                <div className="explore_our_products_card  d-flex justify-content-center align-items-center bg-transparent">
                  <img loading="lazy"  src={color1} alt="banner-1" />
                </div>
              </Link>
            </div>

            <div className="col-xl-2 col-lg-3 col-md-4 col-12">
              <Link to={"/build_your_custom_beteil/product"}>
                <div className="explore_our_products_card  d-flex justify-content-center align-items-center bg-transparent">
                  <img loading="lazy"  src={color2} alt="banner-1" />
                </div>
              </Link>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-4 col-12">
              <Link to={"/build_your_custom_beteil/product"}>
                <div className="explore_our_products_card  d-flex justify-content-center align-items-center bg-transparent">
                  <img loading="lazy"  src={color3} alt="banner-1" />
                </div>
              </Link>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-4 col-12">
              <Link to={"/build_your_custom_beteil/product"}>
                <div className="explore_our_products_card  d-flex justify-content-center align-items-center bg-transparent">
                  <img loading="lazy"  src={color1} alt="banner-1" />
                </div>
              </Link>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-4 col-12">
              <Link to={"/build_your_custom_beteil/product"}>
                <div className="explore_our_products_card  d-flex justify-content-center align-items-center bg-transparent">
                  <img loading="lazy"  src={color2} alt="banner-1" />
                </div>
              </Link>
            </div> */}
        </section>

        <div className="w-100 text-center loadbtn mt-5">
          <Button variant="secondary" onClick={fetchMoreData}>
            Load more
          </Button>
        </div>

        {/* <div className="mt-3">
            <Button
              variant="warning"
              className="fs-24 px-5 py-2 font-inter fw-semibold float-end me-7"
            >
              Next
            </Button>
          </div> */}

        <div className="mt-7">
          <Y_Us_StripComponent />
        </div>
      </div>
    </section>
  );
};

export default ColorCombinationProducts;
